import { OPEN_MODAL } from 'redux/modules/common-modal/actions/types';

import modalOpen from './open-modal-actions';

export default {
  [OPEN_MODAL]: modalOpen,
};
